module.exports = __webpack_public_path__ + "static/media/Dragon Suit Guy.38607898.jpg";